export class DashboardPolygonOptions {
    label!: string;
    value!: string;
  }